import React, { useEffect, useState } from "react";
import { MapPin, Navigation, X, LocateFixed, Loader2 } from "lucide-react";
import { useLocationCtx } from "@/context/LocationContext";
import { api } from "@/lib/api";

// Clear, non-blocking location request. If denied, user can pick a city manually.
export function LocationBar() {
  const { coords, city, chooseCity, status, requestLocation, clearLocation } = useLocationCtx();
  const [cities, setCities] = useState([]);

  useEffect(() => { api.get("/cities").then(({ data }) => setCities(data)); }, []);

  if (coords) {
    return (
      <div data-testid="location-bar-active" className="ts-card p-3 flex items-center justify-between gap-3 flex-wrap">
        <span className="flex items-center gap-2 text-sm text-[var(--emerald)] font-bold">
          <LocateFixed size={16} /> يتم عرض النتائج الأقرب إلى موقعك الحالي
        </span>
        <button data-testid="location-clear" onClick={clearLocation} className="flex items-center gap-1 text-xs text-[var(--text-muted)] hover:text-white">
          <X size={14} /> إيقاف تحديد الموقع
        </button>
      </div>
    );
  }

  return (
    <div data-testid="location-bar-prompt" className="ts-card p-4 flex flex-col sm:flex-row items-center justify-between gap-3">
      <div className="flex items-center gap-2 text-sm text-[var(--text-muted)] text-center sm:text-right">
        <MapPin size={18} className="text-[var(--amber)] shrink-0" />
        <span>فعّل موقعك لعرض أقرب التشاليح إليك، أو اختر مدينتك يدويًا.</span>
      </div>
      <div className="flex items-center gap-2 w-full sm:w-auto">
        <button data-testid="location-enable" onClick={requestLocation} disabled={status === "requesting"}
          className="btn-amber !py-2.5 !px-4 text-sm flex-1 sm:flex-none justify-center disabled:opacity-60">
          {status === "requesting" ? <Loader2 size={16} className="animate-spin" /> : <Navigation size={16} />}
          {status === "requesting" ? "جارٍ التحديد..." : "تحديد موقعي"}
        </button>
        <select data-testid="location-city-select" value={city} onChange={(e) => chooseCity(e.target.value)}
          className="rounded-xl bg-[var(--bg-secondary)] px-3 py-2.5 text-white outline-none text-sm border" style={{ borderColor: "var(--border-c)" }}>
          <option value="">اختر مدينتك</option>
          {cities.map((c) => <option key={c.id} value={c.name}>{c.name}</option>)}
        </select>
      </div>
      {status === "denied" && (
        <p data-testid="location-denied-msg" className="w-full text-xs text-[var(--amber)]">تم رفض إذن الموقع — يمكنك اختيار المدينة يدويًا للمتابعة دون أي قيود.</p>
      )}
    </div>
  );
}

export function mapEmbedUrl(lat, lng) {
  const d = 0.008;
  const bbox = `${lng - d}%2C${lat - d}%2C${lng + d}%2C${lat + d}`;
  return `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat}%2C${lng}`;
}

export function directionsUrl(lat, lng) {
  return `https://www.google.com/maps/dir/?api=1&destination=${lat}%2C${lng}`;
}
